<template>
  <div id="pages-not-found">
    <h1 class="page-message" />
  </div>
</template>

<script>
import Typed from 'typed.js' // eslint-disable-line

export default {
  name: 'NotFound',
  data () {
    return {
      msg: 'notFound',
    }
  },
  mounted () {
    this.msg = new Typed('.page-message', {
      strings: ['<i class="fa fa-blind fa-3"></i> Page Not Found'],
      typeSpeed: 60,
      backDelay: 1000,
    })
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/settings';

#pages-not-found{
  position: relative;
}
.page-message {
  text-align: center;
  height: 50px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
</style>
<style lang="scss">
.typed-cursor{
  display: none;
}
</style>
